import { useEffect, useState } from 'react'
import { Navigate, Outlet, useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { Wrapper } from './styles'
import Container from '../../components/Container'
import MainContent from '../../components/MainContent'
import CatalogHeader from '../../components/ChatbotCatalog/CatalogHeader'
import chatbotApi, { setChatbotToken } from '../../services/chatbotApi'
import LoadingBackground from '../../components/LoadingBackground'
import { useAuth } from '../../context/AuthContext'
import { useTheme } from '../../context/ThemeContext'

const Catalog = () => {
  const { chatbotAuthUser } = useAuth()
  const {updateTheme} = useTheme()
  const navigate = useNavigate()
  const location = useLocation()
  const [searchParams, setSearchParams] = useSearchParams()
  const [customerData, setCustomerData] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  
  const unhashData = async (hash) => {
    try {
      setIsLoading(true)
      const response = await chatbotApi.post('api/v2/chatbot/unhash', hash, {
        headers: { 'Content-Type': 'application/json' }
      });
      if (response.data) {
        const data = response.data.response
        const currentDate = new Date()
        const tokenExpirationDate = new Date(data.dateHashExpiration)
        if (tokenExpirationDate <= currentDate) {
          //token expirado
          return null
        } else {
          setCustomerData(data)
          setChatbotToken(data.token)
          sessionStorage.setItem('customerHashChatbot', hash)
          sessionStorage.setItem('customerChatbot', JSON.stringify(data))
          await chatbotAuthUser(data.customerId, data.buyerId)
          return data
        }
      } else {
        throw new Error("Erro ao obter dados do hash");
      }
    } catch (error) {
      console.error('Erro ao buscar dados:', error)
      throw error
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    const initializeApp = async () => {
      const storedHash = sessionStorage.getItem('customerHashChatbot')
      const storedData = sessionStorage.getItem('customerChatbot')
      const currentUrlHash = searchParams.get('hash')
      setIsLoading(true)

      if (currentUrlHash) {
        try {
          const unhashResponse = await unhashData(currentUrlHash)
          if (!unhashResponse) {
            navigate('/error', { replace: true })
            console.log('Botmaker token expired')
            return
          }
          searchParams.delete('hash')
          setSearchParams(searchParams, { replace: true })
        } catch (error) {
          console.error('Falha ao processar hash da URL')
          navigate('/error', { replace: true })
        } finally {
          setIsLoading(false)
        }
      } else if (storedHash && storedData) {
        const parsedData = JSON.parse(storedData)
        setCustomerData(parsedData)
        parsedData?.token && setChatbotToken(parsedData.token)
        setIsLoading(false)
      } else {
        console.error('Hash não encontrado')
        navigate('/error', { replace: true })
      }
    }

    initializeApp()
  }, [])

  useEffect(() => {
    const loadTheme = async () => {
      await updateTheme(customerData?.ecommerceColors)
    }
    loadTheme()
  }, [customerData])

  useEffect(() => {
    document.documentElement.scrollTop = 0
  }, [location])

  if (isLoading) {
    return <LoadingBackground />
  }

  return (
    <>
      <Container>
        <CatalogHeader />
        <Wrapper>
          <MainContent isChatbotCatalog>
            <Outlet context={{ customerData }} />
          </MainContent>
        </Wrapper>
      </Container>
    </>
  )
}

export default Catalog